export const widgetSelector = state => state.widget;
